import request from '@/utils/request'

// 發送推播根據傳入的旅遊團ID
export function notificationTravels(data) {
  return request({
    url: '/Notification/notificationTravels',
    method: 'post',
    data,
  })
}

// 推播歷史紀錄
export function notificationTravelsLog() {
  return request({
    url: '/Notification/notificationTravelsLog',
    method: 'get',
  })
}
